export const COOKIES = {
  darkMode: 'darkMode',
  language: 'language',
  version: 'version'
}
